import React from "react";
import { Image as ImageIcon, Play } from "lucide-react";

/**
 * Honest labelled slot for a real photo or video — not a fake lifestyle mock.
 * @param {{ label: string, caption?: string, variant?: 'image'|'video', className?: string }} props
 */
export default function PremiumPlaceholder({ label, caption, variant = "image", className = "" }) {
  const Icon = variant === "video" ? Play : ImageIcon;
  return (
    <figure
      className={`photo-slot rounded-2xl border border-dashed border-forest/20 bg-[#F3EEE3] overflow-hidden flex flex-col min-h-[160px] ${className}`}
    >
      <div className="flex-1 flex flex-col items-center justify-center px-5 py-8 text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-forest/10 bg-white/70 px-2.5 py-1 text-[10px] tracking-[0.14em] uppercase text-botanical/55 mb-3">
          <Icon className="w-3.5 h-3.5" strokeWidth={1.5} aria-hidden />
          {variant === "video" ? "Video to come" : "Photo to come"}
        </span>
        <figcaption className="text-sm text-forest/85 font-medium leading-snug max-w-xs">{label}</figcaption>
        {caption ? <p className="mt-2 text-[11px] text-botanical/60 leading-relaxed max-w-sm m-0">{caption}</p> : null}
      </div>
    </figure>
  );
}
